// JavaScript code for acf_blocks/blog-posts-list component
(($) => {

     "use strict";
     console.log("acf_blocks/blog-posts-list scripts loaded...");

})(jQuery);